const GREEN = [145, 238, 124]; // #91EE7C
const TURQUOISE = [144, 238, 184]; // #90EEB8
const TIFFANY = [144, 238, 234]; // #90EEEA

export const COLORS = { GREEN, TURQUOISE, TIFFANY };